import React, { useState, useEffect } from "react";
import logo from "../../../image/Salarytap_logo_horizontal-light_800X239_colored.jpg";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import video from "../../../image/video.mp4";
import { Modal, Button } from "react-bootstrap";
import SalaryTapApk from "../../../apk/Salarytp.apk";
import { toast } from "react-toastify";
import { colors } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

function Navbar() {
  const history = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [show, setShow] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const toggleItem = (index) => {
    console.log("index", index);
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  const handleDownload = () => {
    const screenWidth = window.innerWidth;

    if (screenWidth < 700) {
      // If width is less than 700, navigate to the download page
      history("/salarytap/downloadpage");
    } else {
      // Otherwise, download the APK file directly
      const link = document.createElement("a");
      link.href = SalaryTapApk;
      link.download = "Salarytap.apk"; // Optional: Set the file name
      link.click();
    }
  };

  const faq = [
    {
      question:
        "What is Salarytap and how does it work for employers and employees?",
      answer:
        "Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the <a href='https://shorturl.at/93EjL' style='color: blue;'>Salarytap app</a>, available on the Google Play Store. Employees can withdraw funds 24/7.",
    },
    {
      question: "How do employers set up their workspace on Salarytap?",
      answer: `
      Salarytap is a platform that allows employees to access their salary on demand. Employers can upload their employee data to the Salarytap workspace and set a maximum withdrawal limit for each employee. Once the setup is complete, employees can immediately access funds through the Salarytap app, available on Google Play Store. Employees can withdraw funds instantly.
      `,
    },
    {
      question:
        "Can employers customise Salarytap in their HR App or use their own funds for advancing salary to their employees?",
      answer:
        "Salarytap can be customised to integrate with the employer’s HR app, and if employers prefer to use their own funds for advancing salary, they can integrate their bank account to fund their employees",
    },
    {
      question: "What will it cost the employees?",
      answer: `Employees incur a one-time setup fee of Rs. 300 at the time of their first withdrawal.<br/>
         There is no interest charged, but a flat convenience fee is applied to each withdrawal. `,
    },
    {
      question: "What is the cost of custom integration?",
      answer:
        "Integrating Salarytap into the employer's HR app or choosing to use the employer's funds to facilitate employee funding will cost approximately Rs. 3 to 5 lakhs for each integration.",
    },
    {
      question:
        "What are the steps for employers to enable their employees to withdraw funds?",
      answer:
        "First, you'll need to create your 'Workspace.' After completing your 'Profile,' your workspace will be set up. Once the backend is configured, we'll notify you. At that point, you can upload your employee list, and your employees will be able to start withdrawing funds immediately.",
    },
  ];

  return (
    <>
      <div className="py-3">
        <nav className="container navbar navbar-expand-lg ">
          <div className="d-flex align-items-center">
            <Link className="navbar-brand" to={"/"}>
              <div
                className=" logo-style"
                style={{
                  width: "55%",
                  position: "relative",
                  display: "inline-block",
                }}
              >
                <img
                  src={logo}
                  width="100%"
                  height="100%"
                  alt=""
                  style={{ cursor: "pointer" }}
                  className="hover-image"
                />
                <div
                  className="hover-card card p-3 shadow"
                  style={{
                    width: "24rem",
                    position: "absolute",
                    zIndex: "2",
                    top: "70%",
                    left: "15%",
                    display: "none",
                  }}
                >
                  <p className="text-wrap m-0 " style={{ fontSize: "14px" }}>
                    The green color in the logo and the bird imagery suggest
                    themes of growth, freedom, and financial well-being. The use
                    of a bird in flight symbolizes ease, agility, and
                    liberation, which aligns with the idea of simplifying access
                    to one's salary and improving financial freedom.
                  </p>
                </div>
              </div>
            </Link>
            <button
              className="navbar-toggler mx-3"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{ backgroundColor: "#fff", color: "#fff" }}
            >
              <span className="navbar-toggler-icon" />
            </button>
          </div>
          <div
            className="collapse navbar-collapse justify-content-end text-nowrap"
            id="navbarNav"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item " style={{ margin: "auto 0" }}>
                <Link
                  to={"/salarytap/about"}
                  className="custom-login nav-link d-flex justify-content-center align-items-center text-center"
                  style={{
                    height: "67px",
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                >
                  About
                </Link>
              </li>
              <li className="nav-item " style={{ margin: "auto 0" }}>
                <Link
                  to={"/salarytap/howItWorks"}
                  className="custom-login nav-link d-flex justify-content-center align-items-center  text-center"
                  style={{
                    marginLeft: "2px",
                    height: "67px",
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                >
                  How it works
                </Link>
              </li>
              {/* <li className="nav-item p-1" style={{ margin: "auto 0" }}>
                <Link
                  className="custom-login nav-link d-flex justify-content-center align-items-center  text-center"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  style={{
                    height: "67px",
                    fontSize: "26px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                >
                  <i class="fa-regular fa-circle-play"></i>
                </Link>
              </li>
              <div
                class="modal fade"
                id="exampleModal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <button
                        type="button"
                        className="btn-close m-3"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      />
                      <div
                        className="d-flex justify-content-center"
                        style={{ backgroundColor: "rgb(0 0 0 / 80%)" }}
                      >
                        <video width="600px" height="550px" controls muted>
                          <source src={video} type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <li className="nav-item p-2">
                <Link className="nav-link" to={"/salarytap/pricing"}>
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#000",
                    }}
                  >
                    Pricing{" "}
                  </div>
                </Link>
              </li> */}
              {/* <li className="nav-item p-2">
                <Link className="nav-link" to={"/salarytap/contact"}>
                  <div
                    style={{
                      fontSize: "18px",
                      fontWeight: "500",
                      color: "#000",
                    }}
                  >
                    Contactus
                  </div>
                </Link>
              </li> */}
              <li className="nav-item p-1" style={{ margin: "auto 0" }}>
                <Link
                  className="custom-login nav-link d-flex justify-content-center align-items-center px-2 text-center"
                  to={"/salarytap/login"}
                  style={{
                    height: "67px",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                >
                  LOGIN
                </Link>
              </li>
              {/* <li className="nav-item p-1" style={{ margin: "auto 0" }}>
                <Link
                  className="custom nav-link d-flex justify-content-center align-items-center px-2 text-center"
                  onClick={() => setShowModal(true)}
                  style={{
                    height: "67px",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                >
                  Talk to Sales
                </Link>
              </li> */}
              {/* <Modal
                className=""
                show={showModal}
                onHide={() => {
                  setShowModal(false);
                  setOpenIndex(null);
                }}
                size="lg"
                style={{ background: "rgb(255 255 255 / 40%)" }}
              >
                <Modal.Header closeButton> </Modal.Header>
                <Modal.Body>
                  <h6
                    className="mb-2"
                    style={{ fontWeight: "500", fontSize: "16px" }}
                  >
                    Hi!,
                  </h6>
                  <h6
                    className="mb-4"
                    style={{ fontWeight: "500", fontSize: "16px" }}
                  >
                    Salarytap is a seamless, fully automated process that allows
                    employees to access their salary in advance as soon as the
                    employer finishes setting up the workspace. Employers simply
                    need to create a workspace, fill in a few details, and
                    upload employee data to provide on-demand salary access to
                    their employees. Kindly find some questions and answers
                    intended to offer deeper insight into the product.
                  </h6>

                  {faq.map((item, index) => (
                    <div
                      key={index}
                      className="border px-3 py-2 mb-2 rounded-lg"
                      onClick={() => toggleItem(index)}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className={`d-flex align-items-center justify-content-between ${
                          openIndex === index
                            ? "border-bottom border-secondary pb-2"
                            : ""
                        }`}
                      >
                        <div className="d-flex align-items-center gap-2">
                          <div
                            style={{
                              color: openIndex === index ? "#66a725" : "#000",
                            }}
                            className={`d-flex  font-weight-bold`}
                          >
                            <div className="text-nowrap mr-1">Q.</div>
                            {item.question}
                          </div>
                        </div>
                        <div className="px-2 py-1 rounded">
                          {openIndex === index ? (
                            <i class="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i class="fa-solid fa-chevron-down"></i>
                          )}
                        </div>
                      </div>
                      {openIndex === index && (
                        <div
                          className="pt-2 px-2"
                          style={{ fontSize: "17px" }}
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                      )}
                    </div>
                  ))}
                </Modal.Body>
               
              </Modal> */}

              <li className="nav-item p-1" style={{ margin: "auto 0" }}>
                <Link
                  to={"/salarytap/createYourWorkspace"}
                  className="custom-1 nav-link px-2 py-2 text-center"
                  href="#"
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#fff",
                  }}
                >
                  Create your workspace
                  <br />
                  <span style={{ fontSize: "14px" }}>(For employers)</span>
                </Link>
              </li>
              {/* <li className="nav-item p-1" style={{ margin: "auto 0" }}> */}
              {/* <Link
                  className="custom nav-link px-2 py-2 text-center"
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#66a725",
                  }}
                  onClick={handleDownload}
                >
                  Download App <br />
                  <span style={{ fontSize: "14px" }}>(For employees)</span>
                </Link> */}
              {/* <button
                  className="btn px-3 py-2"
                  style={{
                    background: "#3F86F7",
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#fff",
                    borderRadius: "8px",
                    // padding: "10px 20px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    (window.location.href = "https://shorturl.at/cNKrb")
                  }
                >
                  Download App Link
                </button> */}
              {/* </li> */}
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Navbar;
